export const snackbarsSelector = state => state.appState.notificationState;
